import { render, staticRenderFns } from "./Referee.vue?vue&type=template&id=4d946647&"
import script from "./Referee.vue?vue&type=script&lang=js&"
export * from "./Referee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports